import React from "react";
import { Box, Grid, Link } from "@mui/material";
import WareHouseGraph from "./WareHouseGraph";
import { transformObjectGraph } from "../hooks/format";
import { isBlankOrNull } from "utils";

export default function GraphSection({ graphData, setOpenGraph }) {
  const mapGraphData = () => {
    const data = transformObjectGraph(graphData);
    return data?.map((wh, index) => (
      <Grid container key={index} item justifyContent="center" xs={4} id="graph-section" data-testid="graph-section">
        {wh.rPkgTypeList.map((rType, index) => (
          <WareHouseGraph
            key={index}
            dataSet={rType.dateQtyList}
            subtitle={rType.rPkgType}
            title={`${wh?.whImpExpCd}`}
          />
        ))}
      </Grid>
    ));
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Link href="#" color="#000" onClick={() => setOpenGraph(false)} size="small">
        Close
      </Link>
      <Grid
        container
        columns={{ xs: 6 }}
        justifyContent="space-evenly"
        alignItems="center"
        sx={{
          flexDirection: "column",
          height: 400,
          width: "auto",
          overflowX: "inherit",
          overflowY: "scroll",
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "12px",
          },
        }}>
        {!isBlankOrNull(graphData) && mapGraphData()}
        {/* {graphData?.length > 0 &&
          graphData?.map((wh, index) => (
            <Grid
              container
              key={index}
              item
              justifyContent="center"
              xs={4}
              id="graph-section"
              data-testid="graph-section">
              {wh.rPkgTypeList.map((rType, index) => (
                <WareHouseGraph
                  key={index}
                  dataSet={rType.dateQtyList}
                  subtitle={rType.rPkgType}
                  title={`${wh?.whImpExpCd}`}
                  // title={`${wh?.whCompanyAbbr}:${wh?.whImpExpCd}`}
                />
              ))}
            </Grid>
          ))} */}
      </Grid>
    </Box>
  );
}
